import { LeadSection } from "@/types/lead";
import { DealerDepartment } from "@/types/site";

export function findDepartment(departments: DealerDepartment[], type: LeadSection): DealerDepartment {
  const deparment = departments.find((department) => department.title === type) as DealerDepartment;
  const salesDepartment = departments.find((department) => department.title === LeadSection.SALES) as DealerDepartment;
  const primaryDepartment = departments.find((d) => d.primary === true);
  if (!salesDepartment) {
    console.error("No Sales department");
  }
  return deparment ?? salesDepartment ?? primaryDepartment ?? departments[0];
}
